import { render, staticRenderFns } from "./LanguageBadge.vue?vue&type=template&id=6531458f&scoped=true&"
import script from "./LanguageBadge.vue?vue&type=script&lang=js&"
export * from "./LanguageBadge.vue?vue&type=script&lang=js&"
import style0 from "./LanguageBadge.vue?vue&type=style&index=0&id=6531458f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531458f",
  null
  
)

export default component.exports